import styled from 'styled-components';

import { ImageProps } from './image.types';

export const Image = styled.img<Pick<ImageProps, 'paragraph'>>`
	margin-bottom: ${({ paragraph }) => paragraph};
`;
